import React from "react";
import { Box, Typography } from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css"; 
import { FaPhoneAlt } from "react-icons/fa";
const PhoneNumberField = ({ formik, customHandleChange, t, direction }) => {
  return (
    <Box sx={{ marginBottom: "8px" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: direction === "rtl" ? "row-reverse" : "row", // Reverse for RTL
          justifyContent: direction === "rtl" ? "flex-start" : "", // Adjust justify for RTL
        }}
      >
        <Box
          sx={{
            marginLeft: direction ? "4px" : "0",
            marginRight: direction ? "" : "",
            fontSize: "16px",
          }}
        >
          <FaPhoneAlt style={{ marginRight: "8px", color: "#C49A6C" }} />
        </Box>
        <label
          htmlFor="phone"
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "8px",
            fontSize: "16px",
            fontWeight: 500,
            color: "#676464",
            lineHeight: "16.41px",
            textAlign: direction === "rtl" ? "right" : "left",
          }}
        >
          {t.phoneNumber}
        </label>
        <Typography
          sx={{
            color: "#CA0B0B",
            fontWeight: 700,
            mt: "-18px",
            ml: direction ? "3px" : undefined, // Adjust margins for RTL
            mr: direction ? undefined : "3px", // Adjust margins for RTL
            fontSize: "20px",
          }}
        >
          *
        </Typography>
      </Box>
      <PhoneInput
        country={"sa"} // Default country
        value={formik.values.phone}
        onChange={(value) => {
          formik.setFieldValue('phone', value); // Update Formik value directly
        }}
        onBlur={() => formik.setFieldTouched("phone", true)}
        inputProps={{
          name: "phone",
          required: true,
          placeholder: t.enterPhoneNumber,
        }}
        containerStyle={{ marginTop: "8px" }}
        inputStyle={{
          width: "100%",
          height: "60px",
          borderRadius: '10px',
          borderColor: formik.touched.phone && formik.errors.phone ? "red" : "#ced4da",
          textAlign: direction === "rtl" ? "right" : "left",
          paddingRight: direction === "rtl" ? "40px" : "0px",
          fontFamily:direction === "rtl" ? "Almarai" : "Montserrat",
        }}
      />
      {formik.touched.phone && formik.errors.phone && (
        <span style={{marginLeft:"14px",marginRight:"14px",marginTop:"3px", color: "#d32f2f", fontSize: "12px", textAlign: direction === "rtl" ? "right" : "left",display:"block" }}>
          {formik.errors.phone}
        </span>
      )}
    </Box>
  );
};

export default PhoneNumberField;
